jQuery.noConflict();

(function($) {

    $(document).ready(function($){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a").fancybox();

        AOS.init();

        //AOS.refresh();

        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }

        (function () {
            $('#cn-more-info').on('click', function (e) {
                e.preventDefault();

                $('#cookie-modal').modal();
            });
        })();



        (function() {

            var previousScroll = 0;
            var currentScroll = 0;

            $(window).on("scroll", function(e) {
                //console.log(e);
                var $header_target = $('.navbar-color-on-scroll').data('color-on-scroll');

                if($(window).scrollTop() > $header_target) {
                    $(".navbar-color-on-scroll").removeClass("navbar-transparent");
                } else {
                    //remove the background property so it comes transparent again (defined in css)
                   $(".navbar-color-on-scroll").addClass("navbar-transparent");
                }


                /*if (!isMobile){ 
                    currentScroll = $(this).scrollTop();
                    if (currentScroll > 0 && currentScroll < $(document).height() - $(window).height()) {
                        if (currentScroll >= previousScroll) {
                           return hideNav();
                        } else {
                         return  showNav();
                        }
                        previousScroll = currentScroll;
                    }
                }*/
                
            });


            // Wheel event hook (working perfectly)

            var scrollableElement = document.body; //document.getElementById('scrollableElement');

            if (!isMobile){ 
                scrollableElement.addEventListener('wheel', checkScrollDirection);
            }
           

            function checkScrollDirection(event) {
                    if (checkScrollDirectionIsUp(event)) {
                        showNav();
                    } else {
                        hideNav();
                    }
            }

            function checkScrollDirectionIsUp(event) {
                if (event.wheelDelta) {
                    return event.wheelDelta > 0;
                }
                return event.deltaY < 0;
            }

            function hideNav() {
                $(".navbar-color-on-scroll").removeClass("is-visible").addClass("is-hidden");
            }
        
            function showNav() {
                $(".navbar-color-on-scroll").removeClass("is-hidden").addClass("is-visible").addClass("scrolling");
            }






        })();


        
                

        /**
         * Makes the header cart content scrollable if the height of the dropdown exceeds the window height.
         * Mouseover is used as items can be added to the cart via ajax and we'll need to recheck.
         */
        ( function() {
            if ( document.body.classList.contains( 'woocommerce-cart' ) || document.body.classList.contains( 'woocommerce-checkout' ) || window.innerWidth < 768 || ! document.getElementById( 'site-header-cart' ) ) {
                return;
            }

            window.addEventListener( 'load', function() {
                var cart = document.querySelector( '.site-header-cart' );

                cart.addEventListener( 'mouseover', function() {
                    var windowHeight  = window.outerHeight,
                        cartBottomPos = this.querySelector( '.widget_shopping_cart_content' ).getBoundingClientRect().bottom + this.offsetHeight,
                        cartList      = this.querySelector( '.cart_list' );

                    if ( cartBottomPos > windowHeight ) {
                        cartList.style.maxHeight = '15em';
                        cartList.style.overflowY = 'auto';
                    }
                } );
            } );
        } )();

        (function () {
            let $techDetailsWrapper = $('.technical-details-inner-wrapper');

            $( '.single_variation_wrap' ).on( 'show_variation', function( event, composite ) {
                    let varId = composite['variation_id'];
                    let data = {
                        'varId': varId
                    };

                ajaxHelper(data, 'update_technical_details').then((response) => {
                    $techDetailsWrapper.html(response.items);
                }, (response) => {
                    //console.log(response);
                });

                } );
        })();


        (function () {
            $('.filter-trigger').on('change', function () {
                $(this).closest('form').submit();
            });
        })();

        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });



        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }


        (function () {

            //if (!isMobile){
            if (true){
                let $frame = $('.frame-povjest'),
                     $scrollbar = $frame.parent().find('.o-scrollbar');

                if ($frame.length > 0) {

                    let padding = calc_padding();
                    if(isMobile) {
                        padding -= 5;
                    }

                    $frame.find('.post-slider').css('margin-left', '-' + padding + 'px');
                    //$frame.css('padding-left', calcFluidPadding());
                    // $frame.css('transform', 'translateX(-'+padding+'px)');
                    

                    let povjestiSlider = new Sly($frame, {
                        horizontal: true,
                        itemNav: 'forceCentered',
                        activateMiddle: true,
                        // itemNav: 'basic',
                        // smart: 0,
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: false,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: null,
                        activateOn: 'click',
                        clickBar: true,
                        smart: true,
                        startAt: 0
                    }).init();

                    let $prev = $('.frame-controls .prev'),
                        $next = $('.frame-controls .next');

                    $next.on('click', function () {
                        povjestiSlider.next();
                    });

                    $prev.on('click', function () {
                        povjestiSlider.prev();
                    });
                }
            }

        })();


        (function () {

            if (!isMobile){
                let $frame = $('.frame-diskografija'),
                    $scrollbar = $frame.parent().find('.o-scrollbar');

                    let $contentHolder = $('.diskografija-content-holder');

                if ($frame.length > 0) {

                    let padding = calc_padding();
                    // $frame.css('transform', 'translateX(-'+padding+'px)');
                    $frame.find('.post-slider').css('margin-left', '-' + padding + 'px');

                    let diskografijaSlider = new Sly($frame, {
                        horizontal: true,
                        itemNav: 'forceCentered',
                        activateMiddle: true,
                        // itemNav: 'basic',
                        // smart: 0,
                        mouseDragging: 1,
                        // touchDragging: 1,
                        releaseSwing: false,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: null,
                        startPaused : true,
                        activateOn: 'click',
                        clickBar: true,
                        smart: true,
                        startAt: 0
                    }).init();

                    let $prev = $('.diskografija-controls .prev'),
                        $next = $('.diskografija-controls .next');

                    $next.on('click', function () {
                        diskografijaSlider.next();
                    });

                    $prev.on('click', function () {
                        diskografijaSlider.prev();
                    });

                    diskografijaSlider.on('active', function(e, i) {
                        //console.log('is active', e);

                        let activeItem = diskografijaSlider[i];



                    });
                }
            }

        })();


        (function () {

            if (true){ //!isMobile
                let $frame = $('.emigma-frame'),
                    $scrollbar = $frame.parent().find('.o-scrollbar');

                if ($frame.length > 0) {
                    dynamicElements.push(
                        {
                            'element': $frame,
                            'property': 'padding-left',
                            'callback': calcFluidPadding
                        }
                    );

                    if(!isMobile){
                        $frame.css('padding-left', calcFluidPadding());
                    }


                   /* horizontal: true,
                    activateOn: 'click',
                    itemNav: 'basic',
                    mouseDragging: 1,
                    touchDragging: 1,
                    releaseSwing: false,
                    startPaused : true,
                    speed: 300,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    scrollBar: $scrollbar,*/
                    

                    new Sly($frame, {
                        horizontal: true,
                        activateOn: 'click',
                        itemNav: 'basic',
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: false,
                        startPaused : true,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        //cycleBy: 'items',
                        //cycleInterval: 10000,
                        clickBar: true,
                        smart: true,
                        startAt: 0
                    }).init();
                }
            }

        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

             return ($( 'body' ).width() - $container.width()) / 2;
        }



        function calc_padding() {
            let $container = $('.container');

            let bodyW = $( 'body' ).width();

            let container = $container.width() + 15;

            let padding = (bodyW/2) - ((bodyW - container) / 2) - 50;
            //console.log(padding);
            //
            return padding;

            //return bodyW/2;
            // return ($( 'body' ).width() - $container.width()) / 2;
        }

        //console.log('init'); 

        let mobileMenu = {
            open: false,
            items: {
                //hamburger: $('#burger'),
                burgerWrapper: $('.navbar-toggler'),
                navbar: $('.offcanvas-collapse'),
                body: $('body'),
                html: $('html')
            },
            functions: {
                toggle: function () {
                    //this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.items.html.toggleClass('nav-open');
                    this.open = !this.open;
                },
                open: function () {
                    //this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.items.html.addClass('nav-open');
                    this.open = true;
                },
                close: function () {
                    //this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.items.html.removeClass('nav-open');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        const debounce = (func, delay) => {
            let clearTimer;
            return function() {
                const context = this;
                const args = arguments;
                clearTimeout(clearTimer);
                clearTimer = setTimeout(() => func.apply(context, args), delay);
            }
        }


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {

            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }


        /*$('.navbar-collapse').on('shown.bs.collapse', function (e) {
            // do something…
            $('html').addClass('nav-open');
        });


        $('.navbar-collapse').on('hidden.bs.collapse', function (e) {
            // do something…
            $('html').removeClass('nav-open');
        });*/

       /* $('.frame-diskografija').find('.post-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: true,
            //centerMode: true,
            focusOnSelect: true
          });
*/

        /*
        ******************************************************************************************************
            Tables,
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

        /*(function(){
            $('.timeline-nav').slick({
               slidesToShow: 12,
               slidesToScroll: 1,
               asNavFor: '.timeline-slider',
               centerMode: false,
               focusOnSelect: true,
                mobileFirst: true,
               arrows: false,
               infinite:false,
                responsive: [
                    {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 8,
                    }
                   },
                  {
                   breakpoint: 0,
                   settings: {
                     slidesToShow: 4,
                     slidesToScroll: 2,
                   }
                 }
              ]
           });

            $('.timeline-slider').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: false,
               asNavFor: '.timeline-nav',
               centerMode: true,
               cssEase: 'ease',
                edgeFriction: 0.5,
                mobileFirst: true,
                speed: 500,
                responsive: [
                  {
                   breakpoint: 0,
                   settings: {
                       centerMode: false
                   }
                 },
                    {
                   breakpoint: 768,
                   settings: {
                       centerMode: true
                   }
                 }
              ]
           });

         })();*/


    });

    $(function(){
        $().timelinr({
           orientation: 'horizontal',
           // value: horizontal | vertical, default to horizontal

           containerDiv: '#timeline',
           // value: any HTML tag or #id, default to #timeline

           //<a href="https://www.jqueryscript.net/time-clock/">date</a>sDiv: '#dates',
           // value: any HTML tag or #id, default to #dates

           datesSelectedClass: 'selected',
           // value: any class, default to selected

           datesSpeed: 'normal',
           // value: integer between 100 and 1000 (recommended) or 'slow', 'normal' or 'fast'; default to normal

           issuesDiv : '#issues',
           // value: any HTML tag or #id, default to #issues

           issuesSelectedClass: 'selected',
           // value: any class, default to selected

           issuesSpeed: 'fast',
           // value: integer between 100 and 1000 (recommended) or 'slow', 'normal' or 'fast'; default to fast

           issuesTransparency: 0.2,
           // value: integer between 0 and 1 (recommended), default to 0.2

           issuesTransparencySpeed: 500,
           // value: integer between 100 and 1000 (recommended), default to 500 (normal)

           prevButton: '#prev',
           // value: any HTML tag or #id, default to #prev

           nextButton: '#next',
           // value: any HTML tag or #id, default to #next

           arrowKeys: 'false',
           // value: true/false, default to false

           startAt: 1,
           // value: integer, default to 1 (first)

           autoPlay: 'false',
           // value: true | false, default to false

           autoPlayDirection: 'forward',
           // value: forward | backward, default to forward

           autoPlayPause: 2000
           // value: integer (1000 = 1 seg), default to 2000 (2segs)< });

        });

    });

    /* Custom timeliner linking  owl carousel multiple instances */

    var $shown_items =  $(".top-carousel").data('items');

    $(".bottom-carousel").owlCarousel({
        items: 1,
        loop: false,
        center: false,
        margin: 30,
        autoplay: false,
        //animateIn: 'fadeInRight',
        //animateOut: 'fadeOut',
        //animateIn: 'flipInX',
        mouseDrag: false,
        pullDrag: false,
        URLhashListener:false, 
        //autoplayHoverPause: true,
        navText : ["",""],
        startPosition: 'URLHash',
        responsiveClass: true,
        linked: ".top-carousel",
        nav: false,
        loop: false,
        dots: false,
      });

      

      var oc = $(".top-carousel")
        .on({
            "changed.owl.carousel link.to.owl.carousel": function (e) {
                //console.log(this);
                $(e.currentTarget).find(".owl-item.current").removeClass("current");
    
              if(e.item.index !== null) {
                $(e.currentTarget).find('.owl-item').eq(e.item.index).addClass('current');
              }
    
            },
            "translate.owl.carousel": function(event) {
                //$(this).find(".item").hide();

            },
            "translated.owl.carousel": function(event) {
                //$(this).find(".item").fadeIn(800);

            }
        
        
        })
        .owlCarousel({
          nav: false,
          loop: false,
          dots: false,
          responsiveClass: true,
          margin: 30,
          center: false,
          autoplay: false,
          mouseDrag: false,
          pullDrag: false,
          responsive: {
            0: {
              items: 1,
              nav: false,
              stagePadding:30,
              margin: 15
            },
            600: {
                items: 2,
                nav: false
              },
            1240: {
              items: $shown_items,
              nav: false
            }
          },
          linked: ".bottom-carousel"
        });




        /*oc.on('translate.owl.carousel', function(event) {
            $(this).find(".item").hide();
        });
        
        oc.on('translated.owl.carousel', function(event) {
            $(this).find(".item").fadeIn(800);
        });*/


        /*(function a() {
            a();
        })();*/


})( jQuery );










